const lienPaiement = 'https://origin.diagorisk.com/payer/';
export default lienPaiement